import { useEffect, useState } from "react";
import { deleteCse, fetchCse } from "../../HTTP/thematics";
import SearchComponent from "./SearchComponent";
import TableElements from "./TableElements";
import ListElementsMobile from "./ListElementsMobile";
import Pagination from "../../Helper/Pagination";


export const CseAdmin = () => {
    const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 4) {
        window.location.href = '/'
    }
    const url = new URL(window.location.href)
    if (url.searchParams.get('page') === null) {
        url.searchParams.set('page', 1);
        window.history.pushState({}, '', url);
    }
    const [searchDone, setSearchDone] = useState(false);
    const [launchSearch, setLaunchSearch] = useState(false);
    const [cse, setCse] = useState({});
    const [searchTerm, setSearchTerm] = useState(url.searchParams.get('query') === null ? '' : url.searchParams.get('query'));
    const [currentPage, setCurrentPage] = useState(parseInt(url.searchParams.get('page')));
    const [csePerPage] = useState(100);
    const [nbCse, setNbCse] = useState(0);

    useEffect(() => {
        setSearchDone(false)
        
        const getCse = async () => {
            try {
                const res = await fetchCse((currentPage - 1) * csePerPage, currentPage * csePerPage, searchTerm)
                console.log("res", res)
                setCse(res.data || [])
                setNbCse(res.count)
                setSearchDone(true)  // Déplacé ici pour s'assurer que les données sont chargées
                setLaunchSearch(false)
            } catch (error) {
                console.error("Erreur lors du chargement des CSE:", error)
                setSearchDone(true)  // Important de définir searchDone même en cas d'erreur
                setLaunchSearch(false)
            }
        }
        getCse()
    }, [currentPage, launchSearch, csePerPage])

    const paginate = (pageNumber) => {
        url.searchParams.set('page', pageNumber);
        window.history.pushState({}, '', url);
        setCurrentPage(pageNumber)
    }

    const handleQuery = (e) => {
        e.preventDefault();
        url.searchParams.set('page', 1);
        url.searchParams.set('query', searchTerm);
        setCurrentPage(1)
        window.history.pushState({}, '', url);
        setLaunchSearch(true)
    }

    const handleAddCse = () => {
        window.location.href = '/admin/cse/add'
    }

    const handleEditCse = (id) => {
        window.location.href = '/admin/cse/edit/' + id
    }

    const handleDelete = async (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce CSE ?")) {
            const res = await deleteCse(id)
            if (res) {
                alert("CSE supprimé avec succès")
                setLaunchSearch(true)
            } else {
                alert("Erreur lors de la suppression du CSE")
            }
        }
    }

    console.log("cse", cse)
    console.log("nbCse", nbCse)

    return (
        <div className="flex flex-row mt-8">
            <div className="flex-grow px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row items-center justify-normal sm:justify-between mb-6 mt-8 xl:mt-0">
                    <h1 className="text-2xl font-bold text-center flex-grow mt-2">
                        Modération des CSE
                    </h1>
                </div>
                    <SearchComponent
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    handleQuery={handleQuery}
                    otherButton={{title:'Ajouter', handle:handleAddCse}}
                />
                {cse && cse.length > 0 ? (
                    <>
                <div className='hidden xl:block'>
                    <TableElements 
                        columns={[{props:'name',display:"Thématique"}, 
                        {props:'country',display:"Pays", format:'country'}, 
                        {props:'cse',display:"CSE"}, 
                        {props:'',display:"Actions"}
                        ]}
                        data={cse}
                        buttons={[{display:'Éditer',action:handleEditCse, color:'blue', props:'id'}, 
                        {display:'Supprimer',action:handleDelete, color:'red', props:'id'}]}
                    />
                </div>
                <div className="xl:hidden w-full px-4 space-y-4">
                    <ListElementsMobile 
                        columns={[{props:'name',display:"Thématique"}, 
                            {props:'country',display:"Pays", format:'country'}, 
                            {props:'',display:"Actions"}
                        ]}
                        data={cse}
                        buttons={[{display:'Éditer',action:handleEditCse, color:'blue', props:'id'}, 
                        {display:'Supprimer',action:handleDelete, color:'red', props:'id'}]}
                        little={true}
                    />
                </div>
                {searchDone && <Pagination
                    itemsPerPage={csePerPage}
                    totalItems={nbCse}
                    paginate={paginate}
                    currentPage={currentPage}
                />}</>
                    ) : searchDone ? (
                    <p>Aucune donnée disponible</p>
                    ) : (
                    <p>Chargement en cours...</p>
                )}
                    
            </div>
        </div>
    )
}